module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-800italic.e1b52a7b.woff2";